import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const permissionIndex = document.querySelector('#permission-index')
  if (permissionIndex && !permissionIndex.__vue_app__) {
    createApp({ components: { BaseAlert } }).mount(permissionIndex)
  }
})
